<!-- State Builder > -->
@if (isEdit || isPreview) {
  <div class="grid-x">
    <div class="small-12 text-align-right">
      <span class="checkbox">
        <input class="show-for-sr" type="checkbox" id="Preview" [(ngModel)]="isPreview" (ngModelChange)="togglePreview($event)">
        <label for="Preview" class="inline">
          <span aria-hidden="true" class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
          <span class="control-label-text">Preview Summary</span>
        </label>
      </span>
    </div>
  </div>
}
@if (isEdit) {
  <div class="editing-container">
    @if (!isPreview) {
      <accordion>
        @for (section of dataConfig.configurations; track section) {
          <accordion-panel>
            <div panel-header class="grid-x panel-header">
              <div class="cell small-4">
                {{section.sectionName}}
              </div>
              <div class="cell small-4">
                <div class="checkbox relative">
                  <input class="show-for-sr" type="checkbox" [attr.id]="section.sectionId" [(ngModel)]="section.showHeading">
                  <label aria-hidden="true" [attr.for]="section.sectionId" class="inline">
                    <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
                    <span class="control-label-text">Display</span>
                  </label>
                </div>
              </div>
              <div class="cell small-2 flex align-items-center">
                <label [attr.for]="'displayHeading' + section.sectionId" class="minor-margin-right text-nowrap inline">Label as:</label>
                <input [attr.id]="'displayHeading' + section.sectionId" class="no-margin clear-border" type="text" [(ngModel)]="section.displayHeading" />
              </div>
            </div>
            <table class="summary-table">
              <caption>Summary</caption>
              <tbody>
                <!-- Summary -->
                @for (item of section.summaryItems; track item) {
                  <tr>
                    <td class="section-name-cell padding-left-large relative">
                      <summary-config-item [item]="item"></summary-config-item>
                    </td>
                    <td>
                      <div class="checkbox relative">
                        <input class="show-for-sr" type="checkbox" [attr.id]="section.sectionId + item.questionKey" [(ngModel)]="item.isDisplayed">
                        <label aria-hidden="true" [attr.for]="section.sectionId + item.questionKey" class="inline">
                          <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
                          <span class="control-label-text">Display</span>
                        </label>
                      </div>
                    </td>
                    <td class="label-as-cell">
                      <div class="flex align-items-center">
                        <label for="summaryDisplay" class="minor-margin-right text-nowrap">Label as:</label>
                        <input class="no-margin clear-border" id="summaryDisplay" type="text" [(ngModel)]="item.summaryDisplay" />
                      </div>
                    </td>
                  </tr>
                  @if (item.isDisplayed) {
                    <tr>
                      <td></td>
                      <td colspan="2">
                        <input type="checkbox" [(ngModel)]="item.alwaysShowInSummaries" (click)="onClick(item)">
                        Always show in summaries (regardless of visible rules)
                      </td>
                    </tr>
                  }
                }
                <!-- Context -->
                @for (item of section.contextItems; track item) {
                  <tr>
                    <td class="section-name-cell padding-left-large">
                      {{item.contextValue}}
                    </td>
                    <td>
                      <div class="checkbox relative">
                        <input class="show-for-sr" type="checkbox" [attr.id]="section.sectionId + item.contextValue" [(ngModel)]="item.isDisplayed">
                        <label aria-hidden="true" [attr.for]="section.sectionId + item.contextValue" class="inline">
                          <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
                          <span class="control-label-text">Display</span>
                        </label>
                      </div>
                    </td>
                    <td class="label-as-cell">
                      <div class="flex align-items-center">
                        <label for="contextSummaryDisplay" class="minor-margin-right text-nowrap">Label as:</label>
                        <input class="no-margin clear-border" id="contextSummaryDisplay" type="text" [(ngModel)]="item.summaryDisplay" />
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </accordion-panel>
        }
      </accordion>
    }
  </div>
}

<!-- Flow Component > -->
@if (!isEdit || isPreview) {
  <text-loader [run]="!loaded" [text]="'Loading Summary'" [tickType]="'.'" [interval]="1500"></text-loader>
  <summary-flow-view [anyPending]="anyPending" [config]="dataConfig" [componentContext]="componentContext" [displaySections]="displaySections" [domains]="domains" [flowComponent]="flowComponent" [isPreview]="isPreview" [reviewStatus]="reviewStatus" (navigate)="navigateSection($event)">
  </summary-flow-view>
}
<!-- < Flow Component -->
